/* eslint-disable react/no-children-prop */
import React from 'react';
import { Input, InputGroup, InputProps, InputRightElement } from '@chakra-ui/react';
import { MagnifyingGlass } from 'phosphor-react';

interface SearchFilterProps extends Omit<InputProps, 'onChange'> {
  // eslint-disable-next-line no-unused-vars
  onChange: (eventValue: string) => void;
}

export const SearchFilter = ({ onChange, ...rest }: SearchFilterProps) => {
  return (
    <InputGroup maxWidth="350px">
      <Input
        placeholder="Buscar"
        variant="outline"
        onChange={e => onChange(e.target.value)}
        background="#FAFAFA"
        boxShadow="0px 2px 4px #00000050"
        {...rest}
      />
      <InputRightElement pointerEvents="none" children={<MagnifyingGlass size={20} />} />
    </InputGroup>
  );
};
